<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M25.3532 14.9036C27.8819 14.9036 29.9324 16.6245 29.9324 18.747C29.9324 20.4538 28.6064 21.9009 26.7722 22.4021V26.9348H12.1636V22.4029C10.3274 21.9023 9 20.4545 9 18.7468C9 16.6244 11.05 14.9035 13.5788 14.9035C13.6111 14.9035 13.6433 14.904 13.675 14.9046C13.9615 12.4322 16.4451 10.5 19.4661 10.5C22.4872 10.5 24.9701 12.4323 25.2572 14.9047C25.2895 14.9038 25.3211 14.9036 25.3532 14.9036Z"
    fill="currentColor"
  />
  <path
    d="M12.1631 28.7609H26.7718V30.587C26.7718 31.0912 26.363 31.5 25.8587 31.5H13.0761C12.5719 31.5 12.1631 31.0912 12.1631 30.587V28.7609Z"
    fill="currentColor"
  />
</svg>
